import { render } from "./ProjectManagementLandingPage.vue?vue&type=template&id=17c6085e&scoped=true"
import script from "./ProjectManagementLandingPage.vue?vue&type=script&lang=js"
export * from "./ProjectManagementLandingPage.vue?vue&type=script&lang=js"

import "./ProjectManagementLandingPage.vue?vue&type=style&index=0&id=17c6085e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c6085e"]])

export default __exports__